import { useState } from 'react'
import { CarRank } from '../../../../components/stats/carRank/CarRank'
import { translations } from '../../../../configs/translations'
import { Language } from '../../../../context/LanguageContext'
import './KodLeaderboard.css'
import { KodEventLeaderboardDto } from './KodLeaderboard.types'
// Mock data for development
const mockData: KodEventLeaderboardDto = {
    mapName: "Mock",
    players: [
        {
            place: 1,
            driver: "Driver 1",
            car: "Car 1",
            rank: 1,
            score: 100,
            tandemColor: "#FA9189"
        },
        {
            place: 2,
            driver: "Driver 2",
            car: "Car 2",
            rank: 2,
            score: 200,
            tandemColor: "#FA9189"
        },
        {
            place: 3,
            driver: "Driver 3",
            car: "Car 3",
            rank: 3,
            score: 300,
            tandemColor: "#B3F5BC"
        }
    ]
}

export interface LeaderboardProps {
    leaderboard: KodEventLeaderboardDto | null
    isContinued: boolean
    setIsContinued: (isContinued: boolean) => void
}

export const KodLeaderboard = (props: LeaderboardProps) => {
    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const [isContinuedLocal, setIsContinuedLocal] = useState<boolean>(props.isContinued)

    // Use mock data if no players are provided

    return (
        <div className={isContinuedLocal ? "leaderboard-container board-show-out" : "leaderboard-container"}>
            <div className="table-container">
                <div className='table-title'>
                    <h2 className="table-title-text">{props.leaderboard?.mapName}</h2>
                </div>

                <div className='table-wrapper'>
                    <table className="leaderboard">
                        <thead className="leaderboard-header">
                            <tr className="leaderboard-header-row">
                                <th className="leaderboard-header-cell">{t.place}</th>
                                <th className="leaderboard-header-cell"></th>
                                <th className="leaderboard-header-cell">{t.driver}</th>
                                <th className="leaderboard-header-cell">{t.car}</th>
                                <th className="leaderboard-header-cell">{t.rank}</th>
                                <th className="leaderboard-header-cell">{t.score}</th>
                            </tr>
                        </thead>
                        <tbody className="leaderboard-body">
                            {
                                props.leaderboard?.players.sort((a, b) => b.place - a.place).reverse().map((player, index) => (
                                    <tr key={index}
                                        className="leaderboard-row"
                                        style={{ backgroundColor: player.tandemColor }}
                                    >
                                        <td className="leaderboard-cell">{player.place}</td>
                                        <td className="leaderboard-cell"></td>
                                        <td className="leaderboard-cell">{player.driver}</td>
                                        <td className="leaderboard-cell">{player.car}</td>
                                        <td className="leaderboard-cell">
                                            <div className="car-rank-container">
                                                <CarRank rank={player.rank} />
                                            </div>
                                        </td>
                                        <td className="leaderboard-cell">{player.score}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <div className="continue-button-container"
                    onClick={() => {
                        setIsContinuedLocal(true)
                        props.setIsContinued(true)
                    }}>
                    <div className="continue-button">{t.continue}</div>
                </div>
            </div>
        </div>
    )
}